module.exports = __webpack_public_path__ + "img/bell.0bffb61f.svg";